<template>
  <div>
    <div class="card card-custom">
      <div class="card-header">
        <h4 class="card-title">
          Client List
        </h4>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="form-group col-md-3">
            <label class="form-label">Partner Type</label>
            <v-select placeholder="--Select--" label="Title" :options="partnerTypes" v-model="form.PTR_ID" :reduce="x=>x.ID" />
          </div>
          <div class="form-group col-md-3">
            <label class="form-label">Risk Type</label>
            <v-select placeholder="--Select--" :options="[{ label: 'Low Risk Clients', value: 'Low' },{ label: 'Medium Risk Clients', value: 'Medium' },{ label: 'High Risk Clients', value: 'High' }]" v-model="form.RISK_TYPE" label="label" :reduce="option => option.value" />
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-3">
            <button type="button" class="btn btn-success float-left mr-1" v-on:click="load()">Load</button>
            <button type="button" class="btn btn-success float-left mr-1" @click="clientSummary">Load Summary</button>
          </div>
        </div>
        <table class="table table-sm table-bordered" id="myTable">
          <thead class="bg-custom">
            <tr>
              <th width="5px">Sr.</th>
              <th width="8%">Client Code</th>
              <th width="20%">Name</th>
              <th width="15%">Partner Type</th>
              <th width="10%">Business Nature</th>
              <th width="10%">Address</th>
              <th width="10%">Mobile No</th>
              <th width="10%">GST</th>
              <th width="10%">CNIC</th>
              <th width="10%">NTN</th>
              <th width="5%">Status</th>
              <th width="10%">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,ind) in list" :key="ind">
              <td>{{ind + 1}}</td>
              <td>{{item.BP_CODE_NEW}}</td>
              <td>{{item.BP_DSC}}</td>
              <td>{{item.PTR_TYPE}}</td>
              <td>{{item.BN_DESC}}</td>
              <td>{{item.Addresses}}</td>
              <td>{{item.BP_MOBILE}}</td>
              <td>{{item.BP_GST_NO}}</td>
              <td>{{item.BP_NIC_NO}}</td>
              <td>{{item.BP_NTN_NO}}</td>
              <td><input type="checkbox" :checked="item.BP_ACTIVE == 1" disabled></td>
              <td>
                <button class="btn btn-primary btn-sm" @click="editInsured(item.BP_ID, item.PTR_ID)"><i class="fas fa-pencil-alt" /></button>
                <!--<button class="btn btn-success btn-sm" @click="printKyc(item.BP_ID, item.PTR_ID)"><i class="fas fa-download" /></button>-->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'
  export default ({
    data() {
      return {
        form: {
          PTR_ID: 0,           //PartnerType
          RISK_TYPE: 0,
        },
        partnerTypes: [],
        statuses: [],
        list: [],
      };
    },

    updated() {
      $("#myTable").DataTable();
    },
    created() {
      this.pageload();
    },
    methods: {
      pageload() {
        var vm = this;
        startReq();
        axios.get("/api/UICApi/pageLoadClientDetail")
          .then(function (res) {
            endReq();
            vm.partnerTypes = res.data.partnerTypes;
          })
          .catch((error) => {
            endReq();
            console.log(error);
          })
      },
      editInsured(id, ptrId) {
        if (ptrId == 17 || ptrId == 1) {
          window.open("/uic/IndividualProfile?id=" + id);
          console.log("ptrId value:", ptrId, "type:", typeof ptrId);
        } else {
          window.open("/uic/CorporateProfile?id=" + id);
          console.log("ptrId value:", ptrId, "type:", typeof ptrId);
        }
      },
      load() {
        var vm = this;
        startReq();
        axios.get("/api/UICApi/LoadClienDetails?PTR_ID=" + vm.form.PTR_ID + "&RISK_TYPE=" + vm.form.RISK_TYPE)
          .then(function (res) {
            endReq();
            vm.list = res.data.list;
            var table = $("#myTable").DataTable();
            table.destroy();
          })
          .catch((error) => {
            endReq();
            console.log(error);
          })
      },
      clientSummary(){
        {
          window.open("/UIC/ClientSummary", "_blank");
        }
      },
    },
  })
</script>



// WEBPACK FOOTER //
// src/components/ims/Clientdetails.vue